// extracted by mini-css-extract-plugin
export default {"order-num":"Ee3B9VDxG1seac8GErzn","order":"tJq2UgPs2gUWoEdalXWg"};